import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

// Forum-owned copy of std's SubsPhpbb composition. Every Forum row resolves
// here, regardless of its stored child view/type.
export function ForumPhpbbTemplate({ display, controls, slots }: SubTemplateProps) {
  return (
    <>
      <div className={`md-subs-phpbb-row border border-[#006699] bg-[#dfe6ef] text-[11px] text-black font-[Verdana,Arial,Helvetica,sans-serif]${display.isChecked ? ' md-subs-phpbb-row--checked bg-[#ffffcc]' : ''}`}>
        <div className="md-subs-phpbb-head flex items-center justify-between bg-[#006699] px-2 py-1 text-white">
          <div className="[&_.md-sub-title-link]:text-white">{controls.content.title}</div>
          <div className="text-[10px]">{controls.content.time}</div>
        </div>
        <div className="md-subs-phpbb-body grid grid-cols-[120px_1fr] max-[640px]:block">
          <div className="md-subs-phpbb-user border-r border-[#006699] bg-[#eef3f8] p-2 text-center max-[640px]:border-b max-[640px]:border-r-0">
            <div className="font-bold">{display.identity.author || display.title || 'Member'}</div>
            <div className="mt-2 flex justify-center gap-1">{controls.iconStrip}</div>
          </div>
          <div className="md-subs-phpbb-post p-2">
            <div className="min-h-10 leading-[1.35] [&_.md-sub-text]:whitespace-normal [&_.md-sub-text]:text-black">{controls.content.text}</div>
            <div className="mt-2 border-t border-[#006699] pt-1 text-[10px] text-[#006699]">
              {controls.links.answers}
              {controls.links.submsges}
              {controls.actions.quickReply}
            </div>
          </div>
        </div>
      </div>
      <div className="md-subs-phpbb-children ml-5 border-l-4 border-[#ff6600]">{slots.allChildren}</div>
    </>
  )
}
